var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("fieldset", { staticClass: "product-option" }, [
    _vm.label === "Color"
      ? _c("legend", { staticClass: "product-option__legend" }, [
          _c("span", { staticClass: "product-option__legend--title" }, [
            _vm._v("Select " + _vm._s(_vm.label) + "      "),
          ]),
        ])
      : _vm._e(),
    _vm.label === "Color"
      ? _c(
          "div",
          { staticClass: "swatch__label-wrapper color-selector" },
          [
            _vm._l(_vm.optionSet, function (option) {
              return _c(
                "label",
                {
                  staticClass: "swatch__label",
                  class: {
                    active: option.value === _vm.value,
                    "swatch__label--out-of-stock":
                      _vm.optionIsOutOfStock(option.value) ||
                      _vm.allSizesOutOfStock(option.value),
                  },
                  style: _vm.getStyle(option.value),
                  attrs: { tabindex: "0" },
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.currentValue,
                        expression: "currentValue",
                      },
                    ],
                    staticClass: "u-sr-only",
                    attrs: {
                      type: "radio",
                      tabindex: "-1",
                      id: option.label,
                      name: option,
                    },
                    domProps: {
                      value: option.value,
                      checked: _vm._q(_vm.currentValue, option.value),
                    },
                    on: {
                      change: [
                        function ($event) {
                          _vm.currentValue = option.value
                        },
                        function ($event) {
                          $event.preventDefault()
                          return _vm.onChange(option.value)
                        },
                      ],
                    },
                  }),
                ]
              )
            }),
            _vm.currentValue
              ? _c("span", { staticClass: "product-option__legend--title" }, [
                  _vm._v("Color: " + _vm._s(_vm.currentValue)),
                ])
              : _vm._e(),
          ],
          2
        )
      : _vm._e(),
    _vm.label !== "Color" && !_vm.isDropdown
      ? _c(
          "div",
          {
            staticClass: "product-option__size__list material js-material",
            class:
              _vm.bundleMaterial !== _vm.blank
                ? null
                : "product-option__size__single",
          },
          [
            _vm._l(_vm.optionSet, function (option) {
              return [
                option.url !== _vm.blank
                  ? [
                      _c(
                        "a",
                        {
                          staticClass: "product-option__label",
                          attrs: {
                            "data-title": _vm.bundleMaterial,
                            test: option.value,
                            test2: _vm.value,
                            href: _vm.bundleUrl,
                          },
                        },
                        [_vm._v(_vm._s(_vm.bundleMaterial))]
                      ),
                    ]
                  : [
                      _c(
                        "label",
                        {
                          staticClass: "product-option__label",
                          class: {
                            active: option.value === _vm.value,
                            "swatch__label--out-of-stock":
                              _vm.optionIsOutOfStock(option.value) ||
                              _vm.allSizesOutOfStock(option.value),
                          },
                          attrs: { tabindex: "0", "data-title": option.value },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("is-selected-false")
                            },
                          },
                        },
                        [
                          _vm._v(_vm._s(option.label)),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.currentValue,
                                expression: "currentValue",
                              },
                            ],
                            staticClass: "u-sr-only",
                            attrs: {
                              type: "radio",
                              tabindex: "-1",
                              id: option.label,
                              name: option,
                            },
                            domProps: {
                              value: option.value,
                              checked: _vm._q(_vm.currentValue, option.value),
                            },
                            on: {
                              change: [
                                function ($event) {
                                  _vm.currentValue = option.value
                                },
                                function ($event) {
                                  $event.preventDefault()
                                  return _vm.onChange(option.value)
                                },
                              ],
                            },
                          }),
                        ]
                      ),
                    ],
              ]
            }),
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }